module.exports = __webpack_public_path__ + "resources/img/img_experdb3_m.9e9e949c938dbd9d3e046f4f5e385f43.png";